import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { posts as postsApi } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import PostForm from "../components/posts/PostForm";
import LoadingOverlay from "../components/LoadingOverlay";

export default function EditPostPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    postsApi.get(id).then((data) => {
      setPost(data);
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }, [id]);

  const handleSubmit = async (data) => {
    await postsApi.update(id, { ...data, author_id: user.id });
    navigate(`/posts/${id}`);
  };

  if (loading) return <LoadingOverlay />;
  if (!post) return <p className="text-coral py-8">Post not found</p>;

  return (
    <div>
      <PostForm initial={post} onSubmit={handleSubmit} submitLabel="Save Changes" disableTypeCategory />
    </div>
  );
}
